import { useMemo } from "react";
import ApproachA from "./ApproachA";
import ApproachB from "./ApproachB";
import ApproachC from "./ApproachC";
import ApproachD from "./ApproachD";
import ApproachE from "./ApproachE";

/**
 * 玄関背景のレジストリ。
 * 通常は DEFAULT_KEY の1案を表示する。`/?genkan=b` のように
 * クエリで他案に切り替えられる（確認・デバッグ用）。
 */
const DEFAULT_KEY = "a";
const REGISTRY = {
  a: ApproachA, // 夜の参道（鳥居・灯火）
  b: ApproachB, // 星流れの空
  c: ApproachC, // 水鏡の月
  d: ApproachD, // 雲海の暁
  e: ApproachE, // 蛍の杜
};

export default function GenkanBackground() {
  const Chosen = useMemo(() => {
    try {
      const key = new URLSearchParams(window.location.search).get("genkan");
      if (key && REGISTRY[key]) return REGISTRY[key];
    } catch (e) {
      /* no-op */
    }
    // 2026-10-13: ランダム表示をやめ、A（夜の参道）に固定。他案は ?genkan=b 等で確認できる
    return REGISTRY[DEFAULT_KEY];
  }, []);
  return <Chosen />;
}
